import { render, staticRenderFns } from "./pieItem.vue?vue&type=template&id=b98e71ce&scoped=true"
import script from "./pieItem.vue?vue&type=script&lang=js"
export * from "./pieItem.vue?vue&type=script&lang=js"
import style0 from "./pieItem.vue?vue&type=style&index=0&id=b98e71ce&prod&lang=scss&scoped=true"
import style1 from "./pieItem.vue?vue&type=style&index=1&id=b98e71ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98e71ce",
  null
  
)

export default component.exports